/**
 * ngx-intl-tel-input@17.0.0 (the latest available version) calls the legacy static
 * `BsDropdownModule.forRoot()` at module-evaluation time. ngx-bootstrap removed that
 * static method as of v19+ (BsDropdownDirective now supplies its own providers
 * per-instance, so no root-level provider setup is needed) — without this shim, any
 * chunk that pulls in NgxIntlTelInputModule (results.module.ts, v2/share-results-modal)
 * crashes with "BsDropdownModule.forRoot is not a function" the moment it is evaluated.
 * This restores the old no-op API shape rather than patching the ngx-bootstrap package.
 *
 * This MUST live in the application bundle graph (imported first from main.ts) and not
 * in polyfills.ts: `@angular/build:application` bundles polyfills in a separate esbuild
 * pass with code splitting disabled, so a polyfills-side shim patches a private copy of
 * BsDropdownModule and leaves the copy the lazy chunks actually import untouched.
 */
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

if (typeof (BsDropdownModule as any).forRoot !== 'function') {
  (BsDropdownModule as any).forRoot = () => ({ ngModule: BsDropdownModule, providers: [] });
}
